<template>
  <nav class="config-menu">
    <ul class="config-menu__list">
      <li class="menu-label"><StoreIcon />店舗情報</li>
      <li :class="currentClass('store')"><a href="/store/init">連携設定</a></li>
      <li :class="currentClass('businessday')"><a href="/businessday/init">営業日設定</a></li>
      <li :class="currentClass('businesshour')"><a href="/businesshour/init">営業時間設定</a></li>
      <li class="menu-label"><TableIcon />テーブル情報</li>
      <li :class="currentClass('table')"><a href="/table">テーブル設定</a></li>
      <li :class="currentClass('synchronize')"><a href="/synchronize">予約受付設定</a></li>
      <li :class="currentClass('layout')"><a href="/layout">レイアウト設定</a></li>
      <li :class="currentClass('layoutoption')"><a href="/layout/option">レイアウト表示設定</a></li>
      <li class="menu-label"><StaffIcon />スタッフ情報</li>
      <li :class="currentClass('user')"><a href="/user/init">ログインユーザー設定</a></li>
      <li :class="currentClass('staff')"><a href="/staff/init">スタッフ設定</a></li>
      <li class="menu-label"><LabelIcon />ラベル情報</li>
      <li :class="currentClass('tag')"><a href="/tag">予約タグ設定</a></li>
      <li :class="currentClass('attribute')"><a href="/attribute">お客様特徴設定</a></li>
      <li class="menu-label"><KnifeForkIcon />コース情報</li>
      <li :class="currentClass('coursemenu')"><a href="/coursemenu/init">コース設定</a></li>
      <template v-if="use.reception">
        <li class="menu-label"><CalendarIcon />台帳ネット予約設定</li>
        <li :class="currentClass('/reserve/setting')"><a href="/reserve/setting">予約基本設定</a></li>
        <li :class="currentClass('/reserve/tos')"><a href="/reserve/tos">予約利用規約設定</a></li>
        <li v-if="!use.gnaviCourse" :class="currentClass('/reserve/course')">
          <a href="/reserve/course">コース表示設定</a>
        </li>
        <li :class="currentClass('/reserve/reception')"><a href="/reserve/reception">予約受付設定</a></li>
        <li :class="currentClass('/reserve/reception/group', true)">
          <a href="/reserve/reception/group">予約受付テーブル設定</a>
        </li>
      </template>
      <li class="menu-label"><AddressBookIcon />顧客情報</li>
      <li :class="currentClass('customer/option')"><a href="/setting/customer/option">顧客情報項目の追加</a></li>
      <li v-if="useStoretransfer || useCti || useToreta || useDownload" class="menu-label"><OtherIcon />その他</li>
      <li v-if="useCti" :class="currentClass('cti')"><a href="/cti">着信顧客通知設定</a></li>
      <li v-if="useToreta"><a href="/convert/toreta">データ移管</a></li>
      <li v-if="useStoretransfer" :class="currentClass('transfer')"><a href="/storetransfer">事業譲渡データ移管</a></li>
      <li v-if="useDownload" :class="currentClass('download')"><a href="/download">予約情報ダウンロード</a></li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import { isWebView } from '@/utils/device'
import CalendarIcon from '@/components/icons/CalendarIcon'
import KnifeForkIcon from '@/components/icons/knifeFork'
import LabelIcon from '@/components/icons/label'
import OtherIcon from '@/components/icons/other'
import StaffIcon from '@/components/icons/staff'
import StoreIcon from '@/components/icons/store'
import TableIcon from '@/components/icons/table'
import AddressBookIcon from '@/components/icons/addressBook'

/**
 * 設定画面左カラムメニュー
 */
export default {
  name: 'Navigation',
  components: {
    CalendarIcon,
    KnifeForkIcon,
    LabelIcon,
    OtherIcon,
    StaffIcon,
    StoreIcon,
    TableIcon,
    AddressBookIcon,
  },
  props: {
    /** 表示中のメニュー */
    current: String,
  },
  computed: {
    ...mapState({
      use: state => state.stores.current.store.use,
      transfer: state => state.stores.current.store.storeTransfer,
    }),
    useCti() {
      return this.use.cti && isWebView()
    },
    useToreta() {
      return this.use.toreta && isWebView()
    },
    useDownload() {
      return this.use.reserveCsvDownload && !isWebView()
    },
    useStoretransfer() {
      return this.transfer?.showStoreTransfer
    },
  },
  methods: {
    currentClass(page, isStartsWith = false) {
      return { current: isStartsWith ? this.current.startsWith(page) : this.current === page }
    },
  },
}
</script>

<style lang="postcss" scoped>
.config-menu {
  background-color: var(--white);
  border-right: 1px solid var(--border-color);
  box-sizing: border-box;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;

  .app & {
    height: calc(100vh - 48px - 16px);
  }
}

.config-menu__list {
  list-style: none;
  width: 184px;

  li {
    box-sizing: border-box;
    position: relative;

    &::after {
      background-color: var(--light-gray);
      content: '';
      display: block;
      height: 1px;
      left: 16px;
      position: absolute;
      top: 0;
      width: calc(100% - 32px);
    }

    &:last-child {
      border-bottom: 1px solid var(--border-color);
    }

    &.menu-label {
      align-items: center;
      background-color: var(--very-light-gray-2);
      background-position: 16px 8px;
      background-repeat: no-repeat;
      background-size: 16px 16px;
      color: var(--very-dark-gray-2);
      display: flex;
      font-size: 13px;
      font-weight: bold;
      height: 32px;
      line-height: 33px;
      padding-left: 36px;

      &::after {
        display: none;
      }

      & + li::after {
        display: none;
      }

      svg {
        fill: var(--very-dark-gray-2);
        height: 16px;
        margin: 0 6px 0 -21px;
        width: 16px;
      }
    }

    &.current {
      background-color: var(--very-light-yellow);
    }

    a {
      align-items: center;
      box-sizing: border-box;
      color: var(--text-color);
      display: flex;
      line-height: 26px;
      min-height: 48px;
      padding: 10px 16px;
      text-decoration: none;
    }
  }
}
</style>
